import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="glass-strong sticky top-0 z-50 border-b border-toxic-green/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-discover="true" className="flex items-center gap-2 group" itemScope itemType="https://schema.org/Organization">
            <img 
              src="/images/favicon.webp" 
              alt="Rouge Bets" 
              className="w-8 h-8 group-hover:opacity-80 transition-opacity"
              itemProp="logo"
              loading="eager"
              fetchPriority="high"
              width="32"
              height="32"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-toxic-green to-toxic-cyan bg-clip-text text-transparent" itemProp="name">
              Rouge Bets
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors">
              Accueil
            </Link>
            <Link to="/guides" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors">
              Guides
            </Link>
            <Link to="/reviews" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors">
              Avis
            </Link>
            <Link to="/news" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors">
              Actualités
            </Link>
          </nav>

          <button
            className="md:hidden text-white hover:text-toxic-green transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-4">
              <Link to="/" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors" onClick={() => setIsMenuOpen(false)}>
                Accueil
              </Link>
              <Link to="/guides" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors" onClick={() => setIsMenuOpen(false)}>
                Guides
              </Link>
              <Link to="/reviews" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors" onClick={() => setIsMenuOpen(false)}>
                Avis
              </Link>
              <Link to="/news" data-discover="true" className="text-white/80 hover:text-toxic-green transition-colors" onClick={() => setIsMenuOpen(false)}>
                Actualités
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

